<template>
  <div class="">
    <RouterView></RouterView>
  </div>
</template>
